import { gql } from '@apollo/client'

/**
 * returns ErcotAddressResponse
 */
export const getSuggestedAddresses = gql`
  query GetSuggestedAddresses($address: String!, $zipCode: String) {
    esiidAddress(address: $address, full: true, zipCode: $zipCode) {
      address
      city
      esiid
      meterType
      premiseType
      state
      status
      switchHold
      utilityId
      zipCode
    }
  }
`
